export default "__VITE_ASSET__a833326f__"